import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const Root = styled.div`
  display: grid;
  ${(p) => responsive('gap', p.$gap || p.theme.layout?.grid?.gap || p.theme.space.lg, p.theme)}
  ${(p) => p.$min
    ? responsive('grid-template-columns', p.$min, p.theme, (v) => `repeat(auto-fit, minmax(${v || p.theme.layout?.grid?.minColWidth || '220px'}, 1fr))`)
    : responsive('grid-template-columns', p.$columns || p.theme.layout?.grid?.columns || 12, p.theme, (v) => `repeat(${v}, 1fr)`) }
  width: 100%;
`

// className is forwarded so consumers can extend Grid via styled(Grid)
// e.g. for CSS subgrid on children using & > * selectors
export function Grid({ children, gap, columns, min, className, style }) {
  return (
    <Root $gap={gap} $columns={columns} $min={min} className={className} style={style}>
      {children}
    </Root>
  )
}
